
namespace Gamification.Gamification {
    export class ApiTipiOperazioniColumns {
        static columnsKey = 'Gamification.ApiTipiOperazioni';
    }
}